<template>
  <div class="deactivation-impact-warning-dialog">
    <template v-if="warnings.length > 0">
      <h2 class="section-title">
        {{ $t('corpSetting.tab.member.deactivateConfirm.sectionTitle') }}
      </h2>
      <ul class="warning-list">
        <li
          v-for="warning in warnings"
          :key="warning.type"
          class="warning-item"
        >
          <template v-if="warning.type === 'sisense_dashboard_ownership'">
            <h3 class="warning-message">
              {{ $t('corpSetting.tab.member.deactivateConfirm.sisenseDashboardOwnership.message', { count: warning.count }) }}
            </h3>
            <ul class="dashboard-list">
              <li
                v-for="item in warning.items"
                :key="item.oid"
                class="dashboard-item"
              >
                {{ item.title }}
              </li>
            </ul>
          </template>
          <template v-if="warning.type === 'unsent_mails_ownership'">
            <h3 class="warning-message">
              {{ $t('corpSetting.tab.member.deactivateConfirm.unsentMailsOwnership.message', { count: warning.count }) }}
            </h3>
          </template>
          <template v-if="warning.type === 'sisense_unavailable'">
            <h3 class="warning-message">
              {{ $t('corpSetting.tab.member.deactivateConfirm.sisenseDashboardOwnershipUnknown.message') }}
            </h3>
          </template>
        </li>
      </ul>
    </template>
  </div>
</template>

<script setup lang="ts">
import type { DeactivationWarning } from '@/api/openapi';

defineProps<{
  warnings: DeactivationWarning[];
}>();
</script>

<style lang="scss" scoped>
.deactivation-impact-warning-dialog {
  text-align: left;
  line-height: 1.6;
  padding: 8px 0;
}

.section-title {
  font-size: $fontsize-400;
  font-weight: $font-weight-bold;
  margin: 0 0 16px;
}

.warning-list {
  list-style: disc;
  padding-left: 24px;
  margin: 0;
}

.warning-item {
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }
}

.warning-message {
  font-size: $fontsize-200;
  font-weight: $font-weight-bold;
  margin: 0 0 8px;
}

.dashboard-list {
  list-style: disc;
  padding-left: 24px;
  margin: 0;
}

.dashboard-item {
  font-size: $fontsize-100;
  margin-bottom: 4px;
  line-height: 1.5;
}
</style>
